import router from 'umi/router';

import { getRecord, buyPoint } from 'services';
import { getUrlParam } from 'utils/getValue';
import { urlDelP } from 'utils';
const DELARR = ['ciphertext', 'sign', 'token', 'redirectUrl'];

export default {
  namespace: 'global',
  state: {
    channel: '',
    lg: 'zh-cn',
    recharge: '0',
    cardType: '0',
    dragoncode: '',
  },
  effects: {
    *getRecord({ payload, callback, fail }, { call, put }) {
      const response = yield call(getRecord, payload);
      const state = response.data.state;
      if (state === '11') {
        fail && fail();
      }
      if (state === '11') {
        callback && callback(response);
      }
    },
    *buyPoint({ payload, callback }, { call, put, select }) {
      const response = yield call(buyPoint, {
        ...payload,
      });
      callback && callback(response.data);
    },
    // 删除一些url上的隐秘参数，预防分享出去别人可以用，比如token，
    *handleUrlDep({ payload = {}, callback }, { call, put, select }) {
      try {
        const params = payload.params || [];
        const delParams = [...DELARR, ...params];
        let url = window.history.url;
        delParams.forEach((el) => {
          url = urlDelP(el, url);
        });
        history.replaceState(null, 'null', url);
      } catch (error) {
        console.log(`handleUrlDep---err`, error);
      }
    },
    *handleAfterLogin({ payload = {}, callback, query = {} }, { call, put, select }) {
      try {
        const { data } = payload;
        const { state } = data;
        if (state === '11') {
          const token = data.data.token;
          localStorage.setItem('token', `Bearer ${token}`);
          localStorage.setItem('tokenTimer', new Date().getTime());
          const redirectUrl = getUrlParam('redirectUrl');
          yield put({
            type: 'handleUrlDep',
          });
          if (redirectUrl) {
            const params = query;
            // 删除敏感参数
            DELARR.forEach((el) => {
              delete params[el];
            });
            router.replace({
              pathname: redirectUrl,
              query: params,
            });
            return;
          }
          callback && callback(token);
        }
      } catch (error) {
        console.log(`handleUrlDep---err`, error);
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
